import React from 'react';
import {motion} from 'framer-motion';
import {Card, CardContent, CardHeader, CardTitle, CardDescription} from '../ui/card';
import {Key} from 'lucide-react';
import {useAuth} from '../../contexts/PhpAuthContext';
import {useHospitalAuth} from '../../contexts/HospitalAuthContext';
import ChangePassword from './ChangePassword';

const DoctorSettingsTab = () => {
  const {profile} = useAuth();
  const {hospitalUser} = useHospitalAuth();
  
  // Use hospitalUser if available (hospital login), otherwise use profile (regular login)
  const currentUser = hospitalUser || profile;

  return (
    <div className="space-y-6">
      <motion.div
        initial={{opacity: 0, y: 20}}
        animate={{opacity: 1, y: 0}}
        transition={{duration: 0.4}}
      >
        <h2 className="text-2xl font-semibold text-white mb-6">Settings</h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Change/Reset Password Card */}
          {(() => {
            const canReset = currentUser?.can_reset_password;
            // Accept true, 1, or "1" as enabled
            return canReset === true || canReset === 1 || canReset === '1';
          })() && (
            <Card className="glass-effect border-gray-700">
              <CardHeader>
                <CardTitle className="text-white flex items-center">
                  <Key className="h-5 w-5 mr-2 text-blue-400" />
                  Change/Reset Password
                </CardTitle>
                <CardDescription className="text-gray-300">
                  Change your password or reset it to the default password
                </CardDescription>
              </CardHeader>
              <CardContent>
                <ChangePassword />
              </CardContent>
            </Card>
          )}

          {(() => {
            const canReset = currentUser?.can_reset_password;
            // Show disabled message if not explicitly enabled (true, 1, or "1")
            return !(canReset === true || canReset === 1 || canReset === '1');
          })() && (
            <Card className="glass-effect border-gray-700">
              <CardHeader>
                <CardTitle className="text-white flex items-center">
                  <Key className="h-5 w-5 mr-2 text-gray-400" />
                  Password Reset Disabled
                </CardTitle>
                <CardDescription className="text-gray-300">
                  Password reset is not available for your account
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="p-4 bg-red-500/20 border border-red-500/50 rounded-lg">
                  <p className="text-red-400 text-sm">
                    Your administrator has disabled password reset for your account. 
                    Please contact your administrator to enable this feature.
                  </p>
                </div>
              </CardContent>
            </Card>
          )}
        </div>
      </motion.div>
    </div>
  );
};

export default DoctorSettingsTab;

